interface DialogDimmedProps {
  opacity?: number;
}

export function DialogDimmed({opacity = 0.7}: DialogDimmedProps) {
  return (
    <div
      className="fixed top-0 left-0 h-full w-full bg-static-mono-black"
      style={{opacity}}
    />
  );
}

export const DialogDimmedType = (<DialogDimmed />).type;
